// ----------------------------------------------------------------------

const account = {
  displayName: 'Usuário da Silva(Loja)',
  email: 'teste@email.com',
  photoURL: '/assets/images/avatars/avatar_12.jpg',
};

export default account;
